import {
  MICRO_LOAN_NOTIFICATIONS_ERROR,
  MICRO_LOAN_NOTIFICATIONS_START,
  MICRO_LOAN_NOTIFICATIONS_SUCCESS,
  UNREAD_NOTIFICATIONS_COUNT_SUCCESS,
  READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS,
  READ_MICRO_LOAN_NOTIFICATION_SUCCESS,
} from 'constants/action-types/loanRequests/microLoanNotifications';

export default (state, { type, payload }) => {
  switch (type) {
    case MICRO_LOAN_NOTIFICATIONS_START:
      return {
        ...state,
        microLoanNotifications: {
          ...state.microLoanNotifications,
          loading: true,
          error: null,
        },
      };
    case MICRO_LOAN_NOTIFICATIONS_ERROR:
      return {
        ...state,
        microLoanNotifications: {
          ...state.microLoanNotifications,
          error: payload,
          loading: false,
        },
      };
    case MICRO_LOAN_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        microLoanNotifications: {
          ...state.microLoanNotifications,
          items: payload.data?.rows || [],
          meta: { total: payload.data?.count || 0 },
          error: null,
          loading: false,
        },
      };
    case UNREAD_NOTIFICATIONS_COUNT_SUCCESS:
      return {
        ...state,
        unreadNotificationsCount: payload.data?.count || 0,
      };
    case READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        unreadNotificationsCount: 0,
      };
    case READ_MICRO_LOAN_NOTIFICATION_SUCCESS:
      return {
        ...state,
        unreadNotificationsCount: Math.max(
          0,
          state.unreadNotificationsCount - 1,
        ),
      };
    default:
      return null;
  }
};
